<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        C.E. y pH
      </v-toolbar-title>
      <v-layout>
        <v-flex> </v-flex>
        <v-flex> </v-flex>
        <v-flex> </v-flex>
        <v-flex> </v-flex>
        <v-flex>
          <v-select
            :items="subprojects"
            name="name"
            item-text="name"
            label="Selecciona Rancho"
            @change="selectSubproject($event)"
          />
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" max-width="1400px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <template>
                <div>
                  <v-form v-model="valid1">
                    <v-data-table
                      disable-initial-sort
                      :headers="headers2"
                      :items="items"
                      :pagination.sync="pagination"
                      class="elevation-2"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.nave }}</td>
                        <!-- <td>{{ props.item.sector }}</td> -->
                        <td>
                          <v-text-field
                            v-model="props.item['CE Gotero']"
                            label
                            required
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item['CE Drenaje']"
                            label
                            required
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item['pH Gotero']"
                            label
                            required
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item['pH Drenaje']"
                            label
                            required
                          ></v-text-field>
                        </td>
                        <td class="justify-center">
                          <!-- <v-btn small color="green" @click="submitItem(props)">
                            <v-icon color="white">check</v-icon>
                          </v-btn> -->
                          <v-btn small color="green" @click="submitItem(props)"
                            >Aceptar
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-form>
                </div>
              </template>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      disable-initial-sort
      :headers="headers"
      :items="entry"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.nave }}</td>
        <td class="text-xs-right">{{ props.item.sector }}</td>
        <td class="text-xs-right">{{ props.item["CE Gotero"] }}</td>
        <td class="text-xs-right">{{ props.item["CE Drenaje"] }}</td>
        <td class="text-xs-right">{{ props.item["pH Gotero"] }}</td>
        <td class="text-xs-right">{{ props.item["pH Drenaje"] }}</td>
        <td class="text-xs-right">
          {{ new Date(props.item.createdAt).toLocaleString() }}
        </td>
        <td class="justify-center layout px-0">
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    subprojects: [
      "Andromeda",
      "Aquila",
      "Argus",
      "Aries",
      "Perseo",
      "Aurora",
      "ID",
      "Banco Madre",
    ],
    Andromeda: [
      {
        nave: "Andromeda 1 V.1",
        sector: 1,
      },
      {
        nave: "Andromeda 1 V.2",
        sector: 2,
      },
      {
        nave: "Andromeda 1 V.3",
        sector: 3,
      },
      {
        nave: "Andromeda 1 V.4",
        sector: 4,
      },
      // {
      //   nave: "Andromeda 2 V.1",
      //   sector: 5,
      // },
      // {
      //   nave: "Andromeda 3 V.2",
      //   sector: 6,
      // },
      {
        nave: "Andromeda 4 V.1",
        sector: 7,
      },
      {
        nave: "Andromeda 4 V.2",
        sector: 7,
      },

      {
        nave: "Andromeda 6 V.1",
        sector: 9,
      },
      {
        nave: "Andromeda 6 V.2",
        sector: 9,
      },
      {
        nave: "Andromeda 6 V.3",
        sector: 9,
      },
      {
        nave: "Andromeda 7 V.1",
        sector: 10,
      },
      {
        nave: "Andromeda 7 V.2",
        sector: 10,
      },
      {
        nave: "Andromeda 7 V.3",
        sector: 10,
      },
      {
        nave: "Andromeda 8 V.1",
        sector: 11,
      },
      {
        nave: "Andromeda 8 V.2",
        sector: 11,
      },
      {
        nave: "Andromeda 8 V.3",
        sector: 11,
      },
      
    ],
    Aquila: [
      {
        nave: "Aquila 1 V.1 LADO SUR",
        sector: 1,
      },
      {
        nave: "Aquila 1 V.2 LADO SUR",
        sector: 2,
      },
      {
        nave: "Aquila 1 V.3 LADO NORTE",
        sector: 3,
      },
      {
        nave: "Aquila 1 V.4 LADO NORTE",
        sector: 4,
      },
      {
        nave: "Aquila 2 V.1 LADO SUR",
        sector: 5,
      },
      {
        nave: "Aquila 2 V.2 LADO SUR",
        sector: 6,
      },
      {
        nave: "Aquila 2 V.3 LADO NORTE",
        sector: 7,
      },
      {
        nave: "Aquila 2 V.4 LADO NORTE",
        sector: 8,
      },
      {
        nave: "Aquila 3 V.1",
        sector: 9,
      },
      {
        nave: "Aquila 3 V.2",
        sector: 10,
      },
      {
        nave: "Aquila 4 V.1",
        sector: 11,
      },
      {
        nave: "Aquila 4 V.2",
        sector: 12,
      },
      {
        nave: "Aquila 4 V.3",
        sector: 13,
      },
      {
        nave: "Aquila 5 V.1",
        sector: 14,
      },
      {
        nave: "Aquila 5 V.2",
        sector: 14,
      },
      {
        nave: "Aquila 5 V.3",
        sector: 15,
      },
      {
        nave: "Aquila 6 V.1",
        sector: 14,
      },
      {
        nave: "Aquila 7 V.3",
        sector: 15,
      },
      {
        nave: "Aquila 8 V.1",
        sector: 15,
      },
      {
        nave: "Aquila 8 V.2",
        sector: 16,
      },
      {
        nave: "Aquila 8 V.3",
        sector: 17,
      },
      {
        nave: "Aquila 9 V.1",
        sector: 18,
      },
      {
        nave: "Aquila 9 V.2",
        sector: 19,
      },
      {
        nave: "Aquila 9 V.3",
        sector: 20,
      },
      {
        nave: "Aquila 10 V.1",
        sector: 21,
      },
      {
        nave: "Aquila 10 V.2",
        sector: 22,
      },
      {
        nave: "Aquila 10 V.3",
        sector: 23,
      },
      {
        nave: "Aquila 11 V.1",
        sector: 24,
      },
      {
        nave: "Aquila 11 V.2",
        sector: 25,
      },
      {
        nave: "Aquila 11 V.3",
        sector: 26,
      },
      {
        nave: "Aquila 12 V.1",
        sector: 27,
      },
      {
        nave: "Aquila 12 V.2",
        sector: 28,
      },
      {
        nave: "Aquila 12 V.3",
        sector: 29,
      },
    ],
    Argus: [
      {
        nave: "Argus 4",
        sector: 1,
      },
      {
        nave: "Argus 12",
        sector: 2,
      },
      {
        nave: "Argus 3",
        sector: 3,
      },
      {
        nave: "Argus 10",
        sector: 4,
      },
      {
        nave: "Argus 2",
        sector: 5,
      },
      {
        nave: "Argus 6",
        sector: 6,
      },
      {
        nave: "Argus 6.1",
        sector: 6,
      },
      {
        nave: "Argus 1",
        sector: 7,
      },
      {
        nave: "Per 1 (Argus)",
        sector: 8,
      },
    ],
    Aries: [
      {
        nave: "Aries 1",
        sector: 1,
      },
      {
        nave: "Aries 2",
        sector: 2,
      },
      {
        nave: "Aries 3",
        sector: 3,
      },
      {
        nave: "Aries 4",
        sector: 4,
      },
      {
        nave: "Aries 5",
        sector: 5,
      },
      {
        nave: "Aries 6",
        sector: 6,
      },
      {
        nave: "Aries 7",
        sector: 7,
      },
    ],
    Perseo: [
      {
        nave: "Perseo Acodos",
        sector: "VV02",
      },
      {
        nave: "Perseo Nodriza",
        sector: "VV01",
      },
      {
        nave: "Perseo Semillero",
        sector: "VV03",
      },
      {
        nave: "Perseo SemilleroA",
        sector: "VV03",
      },
      {
        nave: "Perseo SemilleroB",
        sector: "VV05",
      },
      {
        nave: "Perseo EngordaA",
        sector: "EN01",
      },
      {
        nave: "Perseo EngordaB",
        sector: "EN02",
      },

      {
        nave: "Perseo Engorda21A",
        sector: "EN03",
      },
      {
        nave: "Perseo Engorda21B",
        sector: "EN04",
      },
      {
        nave: "Perseo Banco 28lts",
        sector: "BN01",
      },
      {
        nave: "Perseo Banco 165lts",
        sector: "BN02",
      },
    ],
    Aurora: [
      {
        nave: "Aurora 1",
        sector: 1,
      },
      {
        nave: "Aurora 2",
        sector: 2,
      },
      {
        nave: "Aurora 3",
        sector: 3,
      },
      {
        nave: "Aurora 4",
        sector: 4,
      },
      {
        nave: "Aurora 5",
        sector: 5,
      },
      {
        nave: "Aurora 6",
        sector: 6,
      },
      {
        nave: "Aurora 7",
        sector: 7,
      },
      {
        nave: "Aurora 8",
        sector: 8,
      },
      {
        nave: "Aurora 8.1",
        sector: 8,
      },
      {
        nave: "Aurora 9",
        sector: 9,
      },
      {
        nave: "Aurora 10",
        sector: 10,
      },
      {
        nave: "Aurora 11",
        sector: 11,
      },
      {
        nave: "Aurora 12",
        sector: 12,
      },
    ],
    ID: [
      {
        nave: "ID 1",
        sector: 1,
      },
      {
        nave: "ID 2",
        sector: 2,
      },
      {
        nave: "ID 3",
        sector: 3,
      },
      {
        nave: "ID 4",
        sector: 4,
      },
      {
        nave: "ID 5",
        sector: 5,
      },
    ],
    "Banco Madre": [
      {
        nave: "Banco AND1 LADO NORTE V1",
        sector: 1,
      },
      {
        nave: "Banco AND1 LADO SUR V4",
        sector: 2,
      },
      {
        nave: "BANCO AQ2 LADO NORTE V3",
        sector: 3,
      },
      {
        nave: "BANCO AQ2 LADO SUR V1",
        sector: 4,
      },
    ],
    family: [
      "Bonita",
      "Biloxil",
      "Bianca",
      "Julia",
      "Julieta",
      "Victoria",
      "Frambuesa",
    ],
    sector: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    pagination: {
      page: 1,
      rowsPerPage: 60,
    },
    dialog: false,
    headers: [
      {
        text: "Nave",
        // align: 'left',
        sortable: false,
        value: "nave",
      },
      { text: "Sector Riego", value: "sector", align: "right" },
      // { text: 'Variedad', value: 'variedad' },
      { text: "CE Goter", value: "CE Gotero", align: "right" },
      { text: "CE Drenaje", value: "CE Drenaje", align: "right" },
      { text: "pH Gotero", value: "pH Gotero", align: "right" },
      { text: "pH Drenaje", value: "pH Drenaje", align: "right" },
      // { text: 'pH Varilla', value: 'pH Varilla' },
      // { text: 'CE Varilla', value: 'CE Varilla' },
      { text: "Fecha", value: "createdAt", align: "right" },
      { text: "Eliminar", value: "name", sortable: false, align: "center" },
    ],
    headers2: [
      {
        text: "Nave",
        // align: 'left',
        sortable: false,
        value: "nave",
      },
      // { text: "Sector Riego", value: "sector" },
      // { text: 'Variedad', value: 'variedad' },
      { text: "Entrada CE", value: "CE Gotero" },
      { text: "Salida CE", value: "CE Drenaje" },
      { text: "Entrada pH", value: "pH Gotero" },
      { text: "Salida pH", value: "pH Drenaje" },
      // { text: 'pH Varilla', value: 'pH Varilla' },
      // { text: 'CE Varilla', value: 'CE Varilla' },
      { text: "Aceptar", value: "name", sortable: false },
    ],
    valid: true,
    entry: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
  }),
  computed: {
    formTitle() {
      return "Reporte Diario";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.new();
  },
  methods: {
    selectSubproject: async function(event) {
      console.log("event", event);
      this.rancho = event;
      this.dialog = true;
      this.btnClicked(event);
    },
    new() {
      this.$axios
        .get("/api/CeReports/", this.editedItem)
        .then((response) => {
          console.log("resp", response);
          this.entry = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    btnClicked(e) {
      console.log(e);
      this.items = this[`${e}`];
    },
    submitItem(props) {
      console.log(props.item);
      console.log(props.index);

      this.$axios
        .post("/api/CeReports/", props.item)
        .then((response) => {
          if (response.status === 200) {
            this.items = this.items.filter(function(obj) {
              return obj.nave !== props.item.nave;
            });
            alert("Registro enviado!!!");
            this.new();
          } else {
            alert("ERROR");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    deleteItem(item) {
      const index = this.entry.indexOf(item);
      const _id = {
        _id: this.entry[this.entry.indexOf(item)]._id,
      };
      let r = confirm("¿Estas seguro que quieres eliminar este registro?");
      if (r == true) {
        this.entry.splice(index, 1);
        this.$axios.post("/api/DeleteCeReports/", _id);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>

<style scoped>
.v-card {
  padding: 30px !important;
}
</style>
